import { Cinema } from "../cinema-module/cinema";
import { BounceCinema } from "./bounce-cinema";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

eventQBus.on("ft9.bounce.init", () => {
	const cinema = new Cinema();
	cinema.init(1);

	const bounceCinema = new BounceCinema();
	bounceCinema.init();
});
